import GoogleGlyph from './GoogleGlyph';
import { CLOSING, CTA } from './homepageContent';

/**
 * Closing band — the page's last call to action (brief, 2026-11-01): the strategy-and-
 * preparation message, Start Free Trial as the primary action and Sign in with Google as
 * the lighter secondary one. No id: the nav's anchors land on the sections above.
 */

interface ClosingBandProps {
  onLogin: () => void;
  loading: boolean;
}

export default function ClosingBand({ onLogin, loading }: ClosingBandProps) {
  return (
    <section
      aria-labelledby="closing-heading"
      className="border-t border-brass-hairline px-5 sm:px-8 lg:px-14 py-16 sm:py-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8"
    >
      <div className="max-w-[720px]">
        <h2
          id="closing-heading"
          className="font-display font-normal text-[30px] sm:text-[38px] leading-[1.15] text-parchment [text-wrap:balance]"
        >
          {CLOSING.headline}
        </h2>
        <p className="mt-4 text-base leading-[1.7] text-chamber-muted-bright">{CLOSING.copy}</p>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 shrink-0">
        <button
          type="button"
          onClick={onLogin}
          disabled={loading}
          className="bg-brass text-chamber-ink px-8 py-4 text-sm font-semibold tracking-[0.1em] uppercase hover:bg-brass-hover transition-colors disabled:opacity-50 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-brass focus-visible:outline-offset-2"
        >
          {CTA.trial}
        </button>
        <button
          type="button"
          onClick={onLogin}
          disabled={loading}
          className="flex items-center gap-2.5 px-2 py-3 text-sm text-chamber-muted hover:text-brass transition-colors disabled:opacity-50 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-brass focus-visible:outline-offset-2"
        >
          <GoogleGlyph />
          {CTA.signIn}
        </button>
      </div>
    </section>
  );
}
